<!-- START OF MAIN -->
<main class="site-main">
    <!-- START OF BANNER -->
    <section class="inner-banner back-img" style="background-image: url('assets/img/about-us-banner-new.jpg');">
        <div class="banner-stripes">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="banner-shape-wp wow fadeInRight for-des" data-wow-duration=".8s">
            <div class="banner-shape">
                <span class="stripe"></span>
                <span class="stripe stripe-secondary"></span>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="inner-banner-content-wp white-text text-center">
                        <div class="inner-banner-content wow fadeInUp" data-wow-duration=".8s">
                            <h1 class="h2-title mb-0 mt-5">Privacy Policy</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- END OF BANNER -->
    <!-- START OF SERVICES LISTING -->
    <section class="faq-section light-bg">
        <div class="container faq-main-page">
            <div class="row">
                <div class="col-12">
                    <div class="privacy-policy-content wow fadeInLeft" data-wow-duration=".8s" data-wow-delay=".2s">
                        <div class="sec-title my-3 pb-3">
                            <!-- <h2 class="sub-title text-uppercase">
                                <img src="assets/img/setting-icon.svg" width="18" height="18" alt="Setting Icon"> What We Offer 
                            </h2> -->
                            <p>
                                When You access the Service this Privacy Policy presents Our information processing
                                procedures for Your data alongside Your privacy protections under the law and Your
                                related
                                rights.
                            </p>
                            <p>
                                Your data enables us to supply and enhance the Service features. Your use of the Service
                                constitutes acceptance of information gathering procedures defined through this Privacy
                                Policy. This Privacy Policy was created through the assistance of the Privacy Policy
                                Generator.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="theme-text h4-title mb-3">Interpretation and Definitions</h2>
                            <h3 class="text-theme h5-title">Interpretation</h3>
                            <p>
                                The words starting with capital letters throughout this notice carry definitions
                                described under the subsequent conditions. All definitions in here will maintain their
                                definition
                                throughout regardless of number usage.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h3 class="text-theme h5-title">Definitions</h3>
                            <p>
                                For this Privacy Policy:
                            </p>
                            <div class="why-choose-content">
                                <ul>
                                    <li>
                                        <span>
                                            Through Account You gain access to our Service or its specific
                                            parts
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            An affiliate describes an entity which holds control of a party or has its
                                            control from a
                                            party or shares common control with a party when control extends to owning
                                            50% or
                                            more of shares, equity interests or voting securities for director election
                                            or other
                                            management bodies.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The Company that operates under the name golden drop oils maintains its
                                            operations at Al Sajaa industrial area, Near Cement factory, Sharjah, UAE.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Online storage devices called cookies save browsing details on your computer
                                            or
                                            mobile device alongside various other functions.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Country refers to: United Arab Emirates
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The term device refers to products able to connect and access Service
                                            operations
                                            including both computers and mobile cellphones and digital tablets.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            When personal Data relates to a specific person or group who can be
                                            identifiable it
                                            becomes subject to this category.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Service refers to the Website.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The definition of Service Provider denotes any natural or legal person who
                                            executes
                                            data processing assignments for the Company. Third-party companies along
                                            with
                                            individuals working for the Company use the Service to help the Company
                                            execute
                                            the Service or understand how users interact with it while performing tasks
                                            related to
                                            Service delivery.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Usage Data refers to information that is collected automatically by two
                                            accompanying
                                            methods - either from users utilizing the Service or directly from Service
                                            infrastructure
                                            protocols like the length of page visits.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Website refers to golden drop oils, accessible from <a class="text-theme"
                                                href="https://goldendropoils.com/privacy-policy"
                                                target="_blank">https://goldendropoils.com/privacy-policy</a>
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Access to the Service is permitted to You who can be either an individual
                                            person or a
                                            company or other legal entity which the individual represents.
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="theme-text h4-title mb-3">Collecting and Using Your Personal Data</h2>
                            <h3 class="text-theme h5-title mb-3">Types of Data Collected</h3>
                            <h4 class="text-theme h6-title">Personal Data</h4>
                            <p>
                                While using Our Service, We may ask You to provide Us with certain personally
                                identifiable
                                information that can be used to contact or identify You. Personally identifiable
                                information
                                may include, but is not limited to:
                            </p>
                            <div class="why-choose-content mb-3">
                                <ul>
                                    <li>
                                        <span>
                                            Email address
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            First name and last name
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Usage Data
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h4 class="text-theme h5-title mb-3">Usage Data</h4>
                            <p>
                                Usage Data is collected automatically when using the Service
                            </p>
                            <p>
                                Usage Data may include information such as Your Device's Internet Protocol address (e.g.
                                IP address), browser type, browser version, the pages of our Service that You visit, the
                                time
                                and date of Your visit, the time spent on those pages, unique device identifiers and
                                other
                                diagnostic data.
                            </p>
                            <p>
                                When You access the Service by or through a mobile device, We may collect certain
                                information automatically, including, but not limited to, the type of mobile device You
                                use,
                                Your mobile device unique ID, the IP address of Your mobile device, Your mobile
                                operating
                                system, the type of mobile Internet browser You use, unique device identifiers and other
                                diagnostic data.
                            </p>
                            <p>
                                We may also collect information that Your browser sends whenever You visit our Service
                                or
                                when You access the Service by or through a mobile device.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h4 class="text-theme h5-title">Tracking Technologies and Cookies</h4>
                            <p>
                                The Network uses Cookie tools together with similar tracking systems to monitor Service
                                activity while storing specific information. Our Service employs multiple tracking
                                devices
                                including beacons and tags together with scripts to procure information which assists in
                                Service enhancement and data analysis. Our technologies consist of
                            </p>
                            <div class="why-choose-content mb-3">
                                <ul>
                                    <li>
                                        <span>
                                            Cookies or Browser Cookies. When you browse with Your Device a small file
                                            type
                                            known as cookie is placed onto your system. Your browser enables you to
                                            choose
                                            whether to accept or prevent all Cookies from loading or display their
                                            application
                                            during this process. Using Cookies requires Your agreement under our Company
                                            policy but refusal to accept Cookies might result in unable to access
                                            certain parts of
                                            Our Service. When your browser setting has not been modified to reject
                                            Cookies our
                                            Service will still create Cookie files.

                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Web Beacons. Our Service along with email communications includes small
                                            electronic files called web beacons which allow Company to monitor user
                                            interactions
                                            with web pages along with email reading statistics (for system and server
                                            verification
                                            and to count page visitors).

                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h6 class="text-theme h5-title mb-4">
                                Our Service makes use of Session and Persistent Cookies for their specific
                                application areas defined below:
                            </h6>
                            <p>Necessary / Essential Cookies</p>
                            <p><span class="fw-bold">Type:</span> Session Cookies</p>
                            <p><span class="fw-bold">Administered by:</span> Us</p>
                            <p>The Website depends on these essential Cookies to allow users to access its
                                available services as well as several of its important features. These cookies act as
                                user verification modules to secure user accounts against fraudulent activities. The
                                essential Cookies enable Us to provide the services You have requested but We use
                                them only for delivering those services to You.
                            </p>
                        </div>

                        <div class="sec-title mb-4 pb-3">
                            <p>Cookies Policy / Notice Acceptance Cookies</p>
                            <p><span class="fw-bold">Type:</span> Persistent Cookies</p>
                            <p><span class="fw-bold">Administered by:</span> Us</p>
                            <p>Users who accept Website cookie policy usage terms can receive these persistent
                                cookies.
                            </p>
                        </div>

                        <div class="sec-title mb-3">
                            <p>Functionality Cookies</p>
                            <p><span class="fw-bold">Type:</span> Persistent Cookies</p>
                            <p><span class="fw-bold">Administered by:</span> Us</p>
                            <p>The Website remembers choices You make through these Cookies while using its
                                pages including both login details and language settings. With Purpose Cookies the
                                Website provides personalized experiences which help prevent you from retyping
                                preferences when you visit the site.
                            </p>
                        </div>

                        <div class="sec-title mb-4 pb-3">
                            <p>Our Cookies Policy and the Cookies section of our Privacy Policy contain details on the
                                cookies we use with additional information about cookie management.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title">Use of Your Personal Data</h2>
                            <p>
                                The Company may use Personal Data for the following purposes:
                            </p>
                            <div class="why-choose-content mb-3">
                                <ul>
                                    <li>
                                        <span>
                                            Our Service functions require data monitoring to provide and maintain the
                                            operations
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The Service enables You to handle Your Account to manage Your registration
                                            status
                                            as a user of the Service. The Personal Data that You deliver enables You to
                                            access
                                            different options within the Service that come along with your registered
                                            account.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            We use Personal Data to perform all necessary aspects related to contract
                                            development and fulfillment as well as any agreement made through the
                                            Service.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            You will reach You through email or telephone calls and SMS and other
                                            equivalent
                                            electronic communication including mobile application push notifications
                                            through
                                            which we will deliver essential updates and security-related information and
                                            product/service updates when they become necessary.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The Company provides news together with special offers and general
                                            information
                                            about similar goods and services to those You have already obtained unless
                                            You
                                            choose not to receive such communications.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            We will handle Information through Your requests by processing Your requests
                                            directed to Us.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            For business transfers We utilize Your data to determine or execute mergers
                                            as well
                                            as divestitures restructuring or reorganizations dissolutions or any other
                                            transfer of
                                            some or all Our assets whether they are handled as a whole business entity
                                            or part
                                            of bankruptcy liquidation or similar proceedings during which Your Service
                                            user
                                            Personal Data becomes one of the assets being moved.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Our operations span beyond standard service needs through multiple other
                                            functions
                                            including information analysis alongside usage trend identification for
                                            evaluating
                                            promotional effectiveness and enhancing Service, products and marketing
                                            programs.
                                        </span>
                                    </li>
                                </ul>
                            </div>

                            <p class="mt-4">
                                We may share Your personal information in the following situations:
                            </p>
                            <div class="why-choose-content mb-3">
                                <ul>
                                    <li>
                                        <span>
                                            Service Providers receive Your personal information to both monitor our
                                            Service
                                            usage and contact You.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            In case of any business transfer we can share Your personal information
                                            either
                                            during this process or before or after negotiations for any Company asset
                                            sale or
                                            business acquisition or financing deal involving the Company.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            The sharing of Your information occurs with Our affiliates but these
                                            affiliates need to
                                            respect this Privacy Policy. The category of affiliates at Cave of the Winds
                                            includes
                                            Our parent company and any additional subsidiaries or joint venture partners
                                            and
                                            other companies We direct or which operate under shared control.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            When conducting partnerships with business partners we transfer Your
                                            information
                                            for offering specified products or services or promotions.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Any information shared with the public during interactions through our
                                            platform can
                                            become visible to all users while simultaneously spreading outside our
                                            website.
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            We will disclose Your personal information for any other purpose you
                                            authorize us to
                                            share it.
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Retention of Your Personal Data
                            </h2>
                            <p>The Company will store Your Personal Data until all purposes from this Privacy Policy
                                become unnecessary. Your Personal Data remains in our possession for fulfilling our
                                mandatory legal requirements and maintaining dispute resolutions as well as enforcing
                                our
                                legal agreements and policies.</p>
                            <p>Usage Data which the Company maintains will have limited retention for internal
                                analytical
                                purposes. Our Service retains Usage Data for a limited period along with
                                security-related
                                purposes and system performance enhancements and legal information retention
                                requirements.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Transfer of Your Personal Data
                            </h2>
                            <p>Your information together with Personal Data undergoes processing at the Company's
                                operating locations as well as at any facilities where the parties managing the
                                information
                                have their operations. This information has the capability to be transferred to servers
                                existing
                                outside Your state or country or governmental jurisdiction while ensuring different data
                                protection laws may apply to Your jurisdiction.
                            </p>
                            <p>The process of data transfer between Your submission of information through this Privacy
                                Policy agreement serves as Your authorization to permit this transition.
                            </p>
                            <p>This Privacy Policy and its security measures guide the Company as it implements all
                                required measures to protect Your data while the Company does not permit data transfers
                                to
                                organizations or countries without ensuring appropriate security operations for Your
                                personal
                                information.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Delete Your Personal Data
                            </h2>
                            <p>The right to delete personal information collected by Our service exists for You along
                                with
                                the right to ask Our assistance in this process.
                            </p>
                            <p>Our Service provides You with the capability to remove specific information related to
                                You
                                through its built-in features.
                            </p>
                            <p>You can modify your personal information anytime through your Account login to access
                                changes in the account settings section. Using the contact information provided on this
                                webpage customers can order the disclosure or removal or correct any personal data they
                                gave to the Company.
                            </p>
                            <p>
                                We need to keep some information after active cases because legal duties or valid
                                reasons
                                give us this obligation.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Disclosure of Your Personal Data
                            </h2>

                            <h6 class="text-black fw-semibold fs18 mb-2">
                                Business Transactions
                            </h6>
                            <p>The transfer of Your Personal Data becomes possible when the Company executes merger
                                or acquisition or asset disposal transactions. The Company will notify you in advance
                                regarding any transfer of Your Personal Data which will result in different privacy
                                policy
                                regulations.
                            </p>

                            <h6 class="text-black fw-semibold fs18 mb-2 mt-4">
                                Law enforcement
                            </h6>
                            <p>The Company must disclose Your Personal Data according to laws and valid public authority
                                requests which include requirements from courts and government agencies.
                            </p>

                            <h6 class="text-black fw-semibold fs18 mb-2 mt-4">
                                Other legal requirements
                            </h6>
                            <p>The Company will disclose Your Personal Data when it requires good faith reasons to do so
                                including the following cases:
                            </p>
                            <div class="why-choose-content mb-3">
                                <ul>
                                    <li>
                                        <span>
                                            Comply with a legal obligation
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Protect and defend the rights or property of the Company
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Prevent or investigate possible wrongdoing in connection with the Service
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Protect the personal safety of Users of the Service or the public
                                        </span>
                                    </li>
                                    <li>
                                        <span>
                                            Protect against legal liability
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Security of Your Personal Data
                            </h2>
                            <p>Your Personal Data security holds great importance for Us although the Internet lacks
                                absolute security when transmitting digital data or storing electronic information. Our
                                dedication to using commercially acceptable measures for Personal Data protection stands
                                as our priority but the complete security cannot be guaranteed.
                            </p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Children's Privacy
                            </h2>
                            <p>The Service does not accept individual participation from anyone younger than 13 years
                                old.
                                All personal information that we acquire remains restricted to individuals above
                                thirteen
                                years old. You must contact Us when Your child provides Personal Data to Our servers and
                                You hold the role of parent or guardian. We immediately remove any collected 13-year-old
                                personal data when We confirm that parental consent is absent.
                            </p>
                            <p>The requirement for obtaining parent consent from Your country as the legal basis to
                                process Your data prompts Our systems to request parental consent before we collect or
                                use such information.</p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Links to Other Websites
                            </h2>
                            <p>Through Our Service users can find multiple links which direct users to websites not
                                operated by Our company. When clicking third party links on the site You will
                                automatically
                                be redirected to those websites. All Internet visitors should examine the privacy
                                provisions of
                                each website they browse.</p>
                            <p>We maintain no control or responsibility for the third party sites or services which
                                exist
                                outside Our domain.</p>
                        </div>

                        <hr class="mt-4" />
                        <div class="sec-title my-4 py-3">
                            <h2 class="text-theme h5-title mb-4">
                                Changes to this Privacy Policy
                            </h2>
                            <p>Our Privacy Policy can receive periodic updates. The Privacy Policy updates will be
                                notified
                                to you by posting them on this page.</p>
                            <p>You will receive notice from Us through email combined with prominent Service
                                announcements about changes and we will place a new updated date at the top of this
                                Privacy Policy.</p>
                            <p>This Privacy Policy needs periodic review for possible changes so you should check it
                                out.
                                The posted content of this Privacy Policy remains effective at point of publication on
                                this
                                page.</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</main>